// extracted by mini-css-extract-plugin
export default {"row":"Table_row__tuFct","actionWrapper":"Table_actionWrapper__gVkuA","action":"Table_action__GNknW"};